<template>
  <div class="pay-fail">
    <div>
      <iconpark-icon name="close-fill" class="text-[56px]"></iconpark-icon>
    </div>
    <div class="pay-fail__h1">{{ $t('zhi-fu-shi-bai') }}</div>
    <div class="pay-fail__h2">{{ $t('qing-zhong-xin-zhi-fu') }}</div>
    <div>
      <a-button
        type="primary"
        class="mt-[36px] w-[120px]"
        @click="emits('back')"
      >
        {{ $t('zhong-xin-zhi-fu') }}
      </a-button>
    </div>
  </div>
</template>

<script setup lang="ts" name="PayFail">
const emits = defineEmits(['back'])
</script>

<style lang="scss">
.pay-fail {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  &__h1 {
    padding-top: 20px;
    padding-bottom: 16px;
    font-size: 24px;
    font-weight: bold;
    line-height: 34px;
  }
  &__h2 {
    font-size: 14px;
    line-height: 24px;
    opacity: 0.6;
  }
}
</style>
